import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { Leaderboard } from '../components/Leaderboard';

export const PlayerAwardsLeaderboardProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <Leaderboard {...data} />
        </Provider>
    );
};

PlayerAwardsLeaderboardProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
